import { render, staticRenderFns } from "./ExecutionPublicWorksPgHeader.vue?vue&type=template&id=47e9a38c&scoped=true&"
import script from "./ExecutionPublicWorksPgHeader.vue?vue&type=script&lang=js&"
export * from "./ExecutionPublicWorksPgHeader.vue?vue&type=script&lang=js&"
import style0 from "./ExecutionPublicWorksPgHeader.vue?vue&type=style&index=0&id=47e9a38c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e9a38c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardTitle})
